import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';
import cn from 'classnames';
import { useTheme } from '@websky/core/src/theme';
import CheckoutAdditionalService from '../CheckoutAdditionalService';
import Modal from '@websky/core/src/Modal';
import VipServiceSelect from '@websky/core/src/VipServiceSelect';
import { getSegments } from '@websky/core/src/Checkout/store/order/selectors';
import { MOBILE_MIN_WIDTH } from '@websky/core/src/utils';
import { SlideBottom } from '@websky/core/src/SlideBottom/components/SlideBottom';
import { useOrderService } from '@websky/core/src/CheckoutAdditionalService/components/hooks';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { AdditionalServiceType } from '@websky/core/src/CheckoutAdditionalService/types';
import ServiceError from '@websky/core/src/CheckoutAdditionalService/components/ServiceError/ServiceError';
const BusinessService = ({ className, header, service, price }) => {
    const theme = useTheme('CheckoutAdditionalService').Business;
    const segments = useSelector(getSegments);
    const { isSelected, selectedServices, unconfirmedServices, renderSubheader, onOpen, onClose, setOpened, onSaveHandler, onRemoveHandler, passengers, opened } = useOrderService([service], OrderAdditionalServiceGdsServiceServiceType.BusinessLounge);
    const { t } = useTranslation('Checkout');
    const buttons = useMemo(() => {
        if (unconfirmedServices.length) {
            return [
                {
                    className: theme.button__remove,
                    action: () => onRemoveHandler(unconfirmedServices),
                    text: t('Remove'),
                    buttonType: 'change',
                    variant: 'outline'
                }
            ];
        }
        return [
            {
                action: () => setOpened(true),
                text: t('Change'),
                buttonType: 'change'
            }
        ];
    }, [unconfirmedServices]);
    return (React.createElement(React.Fragment, null,
        React.createElement(CheckoutAdditionalService, { header: header, description: service.description, className: cn(theme.business, className), priceFrom: price, priceTotal: price, isSelected: isSelected, addClick: onOpen, descriptionClassName: theme.descriptions, buttons: buttons, serviceType: AdditionalServiceType.BusinessLounge },
            React.createElement(ServiceError, { isShow: !!unconfirmedServices.length },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: service.description } }))),
        React.createElement(MediaQuery, { minWidth: MOBILE_MIN_WIDTH },
            React.createElement(Modal, { classes: { paper: theme.paper }, open: opened, onClose: onClose, maxWidth: "sm" },
                React.createElement(VipServiceSelect, { className: theme.serviceSelect, headerClassName: theme.header, header: header, passengers: passengers, services: [service], segments: segments, onSave: onSaveHandler, selectedServices: selectedServices, onClose: onClose, subheader: renderSubheader() }))),
        React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH },
            React.createElement(SlideBottom, { isOpen: opened, onClose: onClose },
                React.createElement(VipServiceSelect, { className: theme.serviceSelect, headerClassName: theme.header, header: header, passengers: passengers, services: [service], segments: segments, onSave: onSaveHandler, selectedServices: selectedServices, onClose: onClose, subheader: renderSubheader() })))));
};
export default BusinessService;
